import React, { useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import { redirectToExternalUrl, setPathForReEntryRedirect } from 'helpers/RouteHelper';
import { Events, handleAnalytics } from '@foxcorp/delta-web-analytics';
import { FreemiumContext } from 'index/FreemiumProvider';
import { useStartFreeTrialState } from 'components/FloatingStartFreeTrial/FloatingStartFreeTrial.helpers';
import UpgradeButton from 'components/Buythrough/UpgradeButton';
import { PROMO_TYPE_FEATURED_TEXT, getPromoData } from 'helpers/SeriesDetailHelpers';
import style from './StartFreeTrial.css';

const StartFreeTrial = ({ isFreeTrialPlanActive, promos = [] }) => {
  const { isFreemium } = useContext(FreemiumContext);
  const { upsellPromoNavFreemiumCTA, upsellPromoMessage, upsellPromoDescription } = window.Language;
  const promoData = getPromoData({ data: promos, promoType: PROMO_TYPE_FEATURED_TEXT });
  const content = _.get(promoData, 'items.member[0]', {});
  const buttonText = isFreemium ? upsellPromoNavFreemiumCTA : content.ctaText;
  const url = isFreemium
    ? `${_.get(window.ExternalConfig, 'externalSignUpUrl')}/?freemium=true`
    : content.url;
  const divRef = useRef();
  const headline = isFreeTrialPlanActive ? content.headline : upsellPromoMessage;
  const { blackFridaySignUpUrl } = window.ExternalConfig;

  useStartFreeTrialState(divRef, { threshold: 0.1 });
  return (
    <div
      ref={divRef}
      className={classNames([style.container, !isFreeTrialPlanActive && style.joinNowContainer])}
    >
      <h2 className={style.startWatching}>
        {headline} <br />
        {isFreeTrialPlanActive && content.alternativeHeadline}
      </h2>
      {!isFreeTrialPlanActive && <p className={style.description}>{upsellPromoDescription}</p>}
      <UpgradeButton
        onClick={({ isJoinNow }) => {
          handleAnalytics({
            event: Events.PURCHASE_CTA_CLICKED,
            payload: {
              page_item_title: content.headline,
              page_item_subtitle: content.alternativeHeadline,
              page_action_location: 'uspell',
              page_button_text: buttonText,
            },
          });
          if (isFreemium) setPathForReEntryRedirect();
          redirectToExternalUrl(isJoinNow ? blackFridaySignUpUrl : url);
        }}
        theme={style}
      />
    </div>
  );
};

StartFreeTrial.propTypes = {
  isFreeTrialPlanActive: PropTypes.bool,
  promos: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default StartFreeTrial;
